import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

export interface FieldProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export function Field({ children, className, ...props }: FieldProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)} {...props}>
      {children}
    </div>
  )
}

export interface FieldLabelProps extends HTMLAttributes<HTMLLabelElement> {
  children: ReactNode
  htmlFor?: string
}

export function FieldLabel({ children, className, ...props }: FieldLabelProps) {
  return (
    <label className={cn('text-sm font-medium text-warm-gray-600', className)} {...props}>
      {children}
    </label>
  )
}

export interface FieldDescriptionProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode
}

export function FieldDescription({ children, className, ...props }: FieldDescriptionProps) {
  return (
    <p className={cn('text-xs text-warm-gray-400', className)} {...props}>
      {children}
    </p>
  )
}

export interface FieldMessageProps extends HTMLAttributes<HTMLParagraphElement> {
  children?: ReactNode
}

export function FieldMessage({ children, className, ...props }: FieldMessageProps) {
  if (!children) {
    return null
  }

  return (
    <p className={cn('text-xs text-red-500', className)} {...props}>
      {children}
    </p>
  )
}
